import { ReactNode } from 'react'
import styled, { css } from 'styled-components'

import { theme } from '@/styles/theme'
import { PxToVw } from '@/utils/convertPx'

type SectionTitleBackgroundProps = {
  children: ReactNode
  bgColor: 'white' | 'trial-blue' | 'thin-blue'
  outerBgColor: 'white' | 'thin-blue'
  padding: {
    pc: string
    sp: string
  }
}

export const SectionTitleBackground = ({
  children,
  ...rest
}: SectionTitleBackgroundProps) => {
  return <Wrapper {...rest}>{children}</Wrapper>
}

const Arrow = css`
  content: '';
  position: absolute;
  left: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: ${PxToVw(130, 1440)} 50vw 0 50vw;

  @media screen and (max-width: 1047px) {
    border-width: 40px 50vw 0 50vw;
  }
`

const Wrapper = styled.div<Omit<SectionTitleBackgroundProps, 'children'>>`
  position: relative;
  background-color: ${({ bgColor }) =>
    bgColor === 'trial-blue'
      ? `${theme.colors.trialBlue}`
      : bgColor === 'thin-blue'
      ? `${theme.colors.backgroundBlue}`
      : '#fff'};
  padding: ${({ padding }) => padding.pc};

  &::before {
    ${Arrow};
    top: 0;
    border-color: ${({ outerBgColor }) =>
      `${
        outerBgColor === 'thin-blue' ? `${theme.colors.backgroundBlue}` : '#fff'
      } 
      transparent transparent transparent`};
  }

  &::after {
    ${Arrow};
    bottom: 0;
    border-color: ${({ bgColor, outerBgColor }) =>
      `${
        bgColor === 'trial-blue'
          ? `${theme.colors.trialBlue}`
          : bgColor === 'thin-blue'
          ? `${theme.colors.backgroundBlue}`
          : '#fff'
      } 
      ${
        outerBgColor === 'thin-blue' ? `${theme.colors.backgroundBlue}` : '#fff'
      } 
      transparent 
      ${
        outerBgColor === 'thin-blue' ? `${theme.colors.backgroundBlue}` : '#fff'
      }`};
  }

  @media screen and (max-width: 1047px) {
    padding: ${({ padding }) => padding.sp};
  }
`
